import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=b5f2235a&"
import script from "./contents.vue?vue&type=script&lang=ts&"
export * from "./contents.vue?vue&type=script&lang=ts&"
import style0 from "./contents.vue?vue&type=style&index=0&id=b5f2235a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports